import * as React from "react"
import { List, Set } from "immutable"
import { getDrupalVacancies, ApiResult } from "../../custom_api/api"
import { Teaser } from "./teaser"
import { slugify } from "../../custom_utils/helpers"

export interface VacancyOverviewBlockProps {
  readonly title?: string
  readonly html: string
  readonly placeholder: string
  readonly category_id: number
  readonly row_count: number
}

export interface OverviewVacancy {
  title: string
  subtitle: string
  url: string
  locations: string
}

interface VacancyOverviewBlockState {
  vacancies: ApiResult<List<OverviewVacancy>>
}

export class VacancyOverviewBlock extends React.Component<VacancyOverviewBlockProps, VacancyOverviewBlockState> {
  constructor(props: VacancyOverviewBlockProps) {
    super(props)
    this.state = { vacancies: "loading" }
  }

  async componentDidMount() {
    let vacanciesData = await getDrupalVacancies(List([this.props.category_id]))

    if (vacanciesData !== "error") {
      this.setState(s => ({ ...s, vacancies: List<OverviewVacancy>(vacanciesData) }))
    }
  }

  render() {
    let p = this.props
    let s = this.state

    const placeholderText = p.placeholder ?? "Op dit moment zijn er helaas geen vacatures beschikbaar. Maar dat wil niet zeggen dat jij niets voor de bibliotheek kunt betekenen. Stuur ons dus vooral jouw contactgegevens en cv. Wellicht hebben we binnenkort wél een geschikte vacature!"

    return (
      <section className="block block--content-grid block--vacancies richtext-block">
        {(p.title || p.html) && (
          <header className="block__header">
            <h2 data-anchor={slugify(p.title)} className="block__title title--l">{p.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: p.html }} className="block__intro" />
          </header>
        )}

        {s.vacancies !== 'error' && s.vacancies !== 'loading' && (
          !s.vacancies.isEmpty()
            ? <>
              <ul className="teasers row">
                {s.vacancies.map((v, i) => (
                  <Teaser
                    key={`vacancy_overview_${i}`}
                    extraClasses="vacancy col-xs-12 col-sm-6"
                    linkUrl={v.url}
                    headingLevel="h3"
                    title={v.title}
                    intro={v.subtitle}
                    footer={v.locations.split(',').length == 1 ? v.locations : "Meerdere locaties"}
                    row_count={p.row_count}
                  />
                ))}
              </ul>
            </>
            : <p className="weight--bold">
                {placeholderText}
              </p>
        )}
      </section>
    )
  }
}
